export enum CustomLawValidationCode {
    FILE_MAX_SIZE = 'FILE_MAX_SIZE',
    TEXT_MAX_SIZE = 'TEXT_MAX_SIZE',
}
